import React from 'react';
import styled from 'styled-components';
import useProductName from 'brand-customization/useProductName';

import { Button, Col, Row } from 'components/bootstrap';
import ForwarderDiagram from 'forwarder/wizard/ForwarderDiagram';

import { StyledTitle } from './StyledWizardComponents';

const StyledContent = styled.p`
  font-size: 1.2em;
  margin-bottom: 20px;
`;

const StyledDiagram = styled(ForwarderDiagram)`
  margin-top: 35px;
  max-width: 600px;
  width: 100%;
`;

type Props = {
  onStepComplete: () => void;
};

const WelcomeStep = ({ onStepComplete }: Props) => {
  const productName = useProductName();

  return (
    <Row>
      <Col md={5} lg={6}>
        <StyledTitle>Send data to {productName}</StyledTitle>
        <StyledContent>
          Use {productName} Forwarder to get your data into {productName}. The Forwarder runs in your infrastructure and
          can run Inputs that receive logs from your applications and systems. {productName} allows you to set up a
          connection to one or more Forwarders that can send messages.
        </StyledContent>
        <Button bsStyle="primary" onClick={onStepComplete}>
          Start configuration
        </Button>
      </Col>
      <Col md={6} mdOffset={1} lg={4} lgOffset={1}>
        <StyledDiagram />
      </Col>
    </Row>
  );
};

export default WelcomeStep;
